import { NotablesTable } from '@/components/table/NotablesTable/NotablesTable';

export default function NotablesPage() {
  return <NotablesTable />;
}
